import React from 'react'


function CrateTicket() {
    return (
        <div className='container'>
            <div className='row'>
                <div className='col-7 pt-5' style={{ display:'flex', flexDirection: 'column',gap: '2rem'}}>
                    <div className= 'border' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBlock: '0.5rem', paddingInline: '2rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', background: '#E0E0E0', padding: '1rem', borderRadius: '100%' }}>
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </div>
                        <div style={{ fontWeight: 'bold' }}>Account Opening</div>
                        <div><i class="fa fa-chevron-down" aria-hidden="true"></i></div>
                    </div>

                    <div className= 'border' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBlock: '0.5rem', paddingInline: '2rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', background: '#E0E0E0', padding: '1rem', borderRadius: '100%' }}>
                            <i class="fa fa-address-book" aria-hidden="true"></i>
                        </div>
                        <div style={{ fontWeight: 'bold' }}>Your Zerodha Account</div>
                        <div><i class="fa fa-chevron-down" aria-hidden="true"></i></div>
                    </div>
                    <div   className= 'border' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBlock: '0.5rem', paddingInline: '2rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', background: '#E0E0E0', padding: '1rem', borderRadius: '50%' }}>
                            <i class="fa fa-inr" aria-hidden="true"></i>
                        </div>
                        <div style={{ fontWeight: 'bold' }}>Kite</div>
                        <div><i class="fa fa-chevron-down" aria-hidden="true"></i></div>
                    </div>
                    <div className= 'border' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBlock: '0.5rem', paddingInline: '2rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', background: '#E0E0E0', padding: '1rem', borderRadius: '100%' }}>
                            <i class="fa fa-adjust" aria-hidden="true"></i>
                        </div>
                        <div style={{ fontWeight: 'bold' }}>Funds</div>
                        <div><i class="fa fa-chevron-down" aria-hidden="true"></i></div>
                    </div>
                    <div className= 'border' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBlock: '0.5rem', paddingInline: '2rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', background: '#E0E0E0', padding: '1rem', borderRadius: '100%' }}>
                            <i class="fa fa-compress" aria-hidden="true"></i>
                        </div>
                        <div style={{ fontWeight: 'bold' }}>Console</div>
                        <div><i class="fa fa-chevron-down" aria-hidden="true"></i></div>
                    </div>
                    <div className= 'border' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBlock: '0.5rem', paddingInline: '2rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', background: '#E0E0E0', padding: '1rem', borderRadius: '50%' }}>
                            <i class="fa fa-commenting" aria-hidden="true"></i>
                        </div>
                        <div style={{ fontWeight: 'bold' }}>Coin</div>
                        <div><i class="fa fa-chevron-down" aria-hidden="true"></i></div>
                    </div>

                </div>
                <div className='col-4 pt-5' style={{ display:'flex', flexDirection: 'column',gap: '2rem'}}>
                    <div style={{ borderLeft: '8px solid orange', paddingBlock: '2rem', paddingInline:'2rem', backgroundColor:'#F7EBD1'}}>
                        <ul>
                            <li>Surveillance measure on scrips - February 2026</li>
                            <li>Latest Intraday leverages and Square-off timings</li>
                        </ul>
                    </div>
                    <div className='border' >
                        <h5 style={{padding: '1.5rem', backgroundColor:'#E0E0E0'}}>Quick links</h5>
                        <ol style={{ display: 'flex', flexDirection:'column', gap:'1rem', justifyContent: 'space-between', padding:'2rem'}}>
                            <li>Track account opening</li>
                            <li>Track segment activation</li>
                            <li>Intraday margins</li>
                            <li>Kite user manual</li>
                            <li>Learn how to create a ticket</li>
                        </ol>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default CrateTicket;